<template>
	<div class="skills">
		<!-- Tab content area -->
        <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3">
            <div class="c-user-tab-content clearfix o-skillset-area">
            <div v-for="(skill,index) in skills" :key="index" class="col-md-3 table-td-border-right">
                <ul class="c-skillset">
                    <li><span>{{skill.name}} {{ getSkillSeniority(skill.id) ? '('+getSkillSeniority(skill.id)+')' : ''}}</span> <i class="fa fa-star"></i> </li>
                </ul>                        
            </div>
            </div>
        </div>
        <!-- /Tab content area -->
	</div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import dateTimeConvert from '../../timeConvert&Compare';
    import service from '../../services.js';
    export default {
        props: {
            userProfile: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID'
            })
        },
        data() {
            return {
                skills: [],
                skill_seniorities: []
            }
        },
        watch: {
            userProfile: function(newData) {
                this.userBasic = newData;
                this.skills = this.userBasic.skills;
                this.skill_seniorities = this.userBasic.skill_seniority;
            }
        },
        methods: {
            getSkillSeniority(id) {
                let index = this.skill_seniorities.findIndex((item) => item.skill_id === id )
                if(index !== -1) {
                    return this.skill_seniorities[index].seniority
                }
            }

        },
        beforeMount() {
            this.skills = this.userProfile.skills;
            this.skill_seniorities = this.userProfile.skill_seniority;
            //console.log(this.skills);
        },
        created() {

        }
    }

</script>
